import { FormContext, formContextInitialValue } from "@toolkit/Framework/Components/FormContext/FormContext";
import { FormModel } from "@toolkit/Framework/Store/Toolkit/Components/Form/FormTypes";
import React, { FC, PropsWithChildren } from "react";

export interface FormContextProviderProps {
    form: FormModel | null;
}

export const FormContextProvider: FC<PropsWithChildren<FormContextProviderProps>> = ({ form, children }) => {
    return <FormContext.Provider value={form || formContextInitialValue}>{children}</FormContext.Provider>;
};
